import PropTypes from "prop-types";
import React from "react";

class WsExceptionStatus extends React.PureComponent {
  static get propTypes() {
    return {
      exception: PropTypes.number,
    };
  }

  renderExceptionCode(exception) {
    return exception ? (
      <span title="Connection error code.">
        (<span className="ws-exception-code">{exception}</span>)
      </span>
    ) : null;
  }

  render() {
    const { exception } = this.props;

    return (
      <div className="ws-status-widget">
        {this.renderExceptionCode(exception)}
      </div>
    );
  }
}

export { WsExceptionStatus };
